import { app } from '@/main'

export default {
  roleName(state) {
    if (!state.userInfo) return ''
    switch (state.userInfo.role_id) {
      case 10001:
        return app.$ct('master')
      case 10002:
        return app.$ct('teacher')
      case 20001:
        return app.$ct('student')
      default:
        return ''
    }
  }
}
